import React, { FC } from "react";
import { Helmet } from "react-helmet";

interface IMetaTagsProps {
  title?: string | null;
  description?: string | null;
  ogImage?: string | null;
  ogImageAlt?: string | null;
  ogImageType?: string | null;
}

export const MetaTags: FC<IMetaTagsProps> = ({ title, description, ogImage, ogImageAlt, ogImageType }) => {
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {title && <meta property="og:title" content={title} />}

      <meta property="og:type" content="website" />
      {window && <meta property="og:url" content={window.location.origin + window.location.pathname} />}

      {description && <meta name="description" content={description} />}
      {description && <meta name="og:description" content={description} />}

      {ogImage && <meta property="og:image" content={ogImage} />}
      {ogImage && <meta property="og:image:url" content={ogImage} />}
      {ogImage && <meta property="og:image:type" content={ogImageType ?? "image/jpeg"} />}
      {ogImage && <meta property="og:image:width" content="632" />}
      {ogImage && <meta property="og:image:height" content="330" />}
      {ogImage && ogImageAlt && <meta property="og:image:alt" content={ogImageAlt} />}
    </Helmet>
  );
};
